<script lang="ts">
  import {_} from 'svelte-i18n'
  import {createEventDispatcher} from "svelte"
  import {activeTags, globalSearch, groups, isDirtySearch, isShowSearchLoader, searchTitle} from "../../stores";

  const dispatch = createEventDispatcher()

  const isMobile = screen.width <= 576

  let searchInput: HTMLInputElement

  const clearSearch = () => {
    globalSearch.set('')
    searchInput.focus()
  }

  const inputKeydownHandler = async (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      await searchHandler()
      searchInput.blur()
    }
  }

  const searchHandler = async () => {
    const isNotEmptySearch = !!$globalSearch.length
    const isActiveTags = !!$activeTags.length

    isShowSearchLoader.set(true)
    searchTitle.set($globalSearch)
    isDirtySearch.set(isNotEmptySearch || isActiveTags)

    dispatch('search')

    if (searchInput) {
      searchInput.scrollLeft = 0;
    }
  }
</script>

<div class="global-search" style:margin-top={$groups.length > 1 && isMobile ? '40px' : '0'}>
  <input
    bind:this={searchInput}
    bind:value={$globalSearch}
    type="text"
    placeholder={$_('whatSearch')}
    on:keydown={inputKeydownHandler}
  />
  {#if $globalSearch}
    <i
      class="icon-cross"
      on:click={clearSearch}
      on:keydown={clearSearch}
    />
  {/if}
  <i
    class="icon-search"
    on:click={searchHandler}
    on:keydown={searchHandler}
  />
</div>

<style lang="scss">
  .global-search {
    position: relative;
    display: flex;

    input {
      width: 100%;
      padding: 16px 80px 16px 16px;
      border-radius: 12px;
      font-size: 16px;
      line-height: 23px;
      background: #EFF1FD;
      border: 1px solid #EFF1FD;
      outline: none;

      &:focus {
        outline: none;
        border: 1px solid #576CED;
      }

      &::placeholder {
        color: #8B8F99;
      }
    }

    i {
      color: #BDBFC4;
      position: absolute;
      cursor: pointer;
    }

    .icon-cross {
      top: 19px;
      right: 48px;
      font-size: 14px;
    }

    .icon-search {
      top: 18px;
      right: 16px;
      font-size: 16px;
      transform: rotate(90deg);
    }
  }
</style>